<template>
  <section class="border-t border-default/60 bg-default">
    <UContainer class="py-12 sm:py-14">
      <div class="mx-auto max-w-md space-y-4">
        <h2
          v-if="title"
          class="text-center text-xl font-semibold"
        >
          {{ title }}
        </h2>
        <p
          v-if="subtitle"
          class="text-center text-sm text-muted"
        >
          {{ subtitle }}
        </p>
        <form
          class="space-y-3"
          @submit.prevent="submit"
        >
          <UFormField label="نام">
            <UInput
              v-model="name"
              :disabled="builderPreview"
            />
          </UFormField>
          <AuthPhoneInput v-model="phone" />
          <UFormField label="شرح مشکل">
            <UTextarea
              v-model="complaint"
              :rows="4"
              :disabled="builderPreview"
            />
          </UFormField>
          <UButton
            type="submit"
            block
            class="min-h-11"
            :loading="saving"
            :disabled="!canSubmit"
          >
            ارسال مشاوره
          </UButton>
        </form>
        <p
          v-if="done"
          class="text-center text-sm text-primary"
        >
          درخواست شما ثبت شد.
        </p>
        <p
          v-if="error"
          class="text-center text-sm text-error"
        >
          {{ error }}
        </p>
      </div>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
import AuthPhoneInput from '~/components/auth/PhoneInput.vue'
import { isCompleteIrMobile } from '~/utils/phone'
import { apiErrorMessage } from '~/utils/apiError'

const props = defineProps<{
  title?: string
  subtitle?: string
  builderPreview?: boolean
}>()

const name = ref('')
const phone = ref('')
const complaint = ref('')
const saving = ref(false)
const done = ref(false)
const error = ref('')
const canSubmit = computed(() => (
  !props.builderPreview && isCompleteIrMobile(phone.value) && name.value.trim().length >= 2 && complaint.value.trim().length >= 3
))

async function submit() {
  if (!canSubmit.value) return
  saving.value = true
  error.value = ''
  try {
    await $fetch('/api/leads/consultations', {
      method: 'POST',
      body: { name: name.value, phone: phone.value, chiefComplaint: complaint.value },
    })
    done.value = true
  }
  catch (err) {
    error.value = apiErrorMessage(err, 'ارسال ناموفق بود')
  }
  finally {
    saving.value = false
  }
}
</script>
